import React from 'react';
import styled from 'styled-components';

const ButtonContainer = styled.div`
  border: solid 4px white;
  width: 50px;
  height: 64px;
  color: white;
  background: rgba(63, 63, 63, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15%;
  padding: 0px;
  flex-direction: column;
  border-top: solid 2px white;
  border-bottom: solid 2px white;
  &:last-child: {
    border-bottom: none;
  }
`;
const ButtonEle = styled.div`
  border-bottom: solid 4px white;
  width: 100%;
  height: 50%;
  text-align: center;
  border-radius: 0;
  border-top: solid 4px white;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  &:last-child: {
    border-bottom: none;
  }
`;
const Indicator = styled.span`
  width: 10px;
  height: 10px;
  background: rgba(106, 106, 106, 1);
  border-radius: 50%;
  display: inline-block;
`;
const DoubleButton = ({
  options = [],
  distinctButtons = false,
}: {
  options: string[];
  distinctButtons?: boolean;
}) => {
  return (
    <ButtonContainer>
      {/* <div> */}
      {options.map((option) => (
        <ButtonEle key={option}>
          <Indicator />
          {option}
        </ButtonEle>
      ))}
      {/* </div> */}
    </ButtonContainer>
  );
};

export default DoubleButton;
